import * as React from "react";
import type { SVGProps } from "react";
const SvgPoweredByStripe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={100}
    height={67}
    {...props}
  >
    <defs>
      <clipPath id="powered-by-stripe_svg__b">
        <path d="M0 0h100v67H0z" />
      </clipPath>
      <clipPath id="powered-by-stripe_svg__c">
        <path d="M0 0h100v67H0z" />
      </clipPath>
      <mask id="powered-by-stripe_svg__e">
        <g filter="url(#powered-by-stripe_svg__a)">
          <path
            d="M0 0h100v67H0z"
            style={{
              fill: "#000",
              fillOpacity: 0.34902,
              stroke: "none",
            }}
          />
        </g>
      </mask>
      <mask id="powered-by-stripe_svg__g">
        <g filter="url(#powered-by-stripe_svg__a)">
          <path
            d="M0 0h100v67H0z"
            style={{
              fill: "#000",
              fillOpacity: 0.501961,
              stroke: "none",
            }}
          />
        </g>
      </mask>
      <g
        id="powered-by-stripe_svg__d"
        clipPath="url(#powered-by-stripe_svg__b)"
      >
        <path
          d="M84.582 41.945H15.418c-2.145 0-3.879-1.746-3.879-3.898v-9.094c0-2.152 1.734-3.898 3.879-3.898h69.164c2.145 0 3.879 1.746 3.879 3.898v9.094c0 2.152-1.734 3.898-3.879 3.898m3.234-12.992c0-1.793-1.449-3.25-3.234-3.25H15.418a3.244 3.244 0 0 0-3.234 3.25v9.094c0 1.793 1.449 3.25 3.234 3.25h69.164a3.244 3.244 0 0 0 3.234-3.25Zm0 0"
          style={{
            stroke: "none",
            fillRule: "evenodd",
            fill: "#424770",
            fillOpacity: 1,
          }}
        />
      </g>
      <g
        id="powered-by-stripe_svg__f"
        clipPath="url(#powered-by-stripe_svg__c)"
      >
        <path
          d="M50.777 37.031h-.843l.652-1.62-1.3-3.294h.89l.816 2.242.824-2.242h.891Zm-3.238-1.414c-.293 0-.594-.11-.867-.32v.238h-.867v-4.914h.867v1.727c.273-.203.574-.313.867-.313.91 0 1.535.738 1.535 1.79 0 1.054-.625 1.792-1.535 1.792m-.184-2.832c-.238 0-.476.106-.683.309v1.465c.207.203.445.304.683.304.489 0 .829-.422.829-1.039 0-.613-.34-1.039-.829-1.039m-5.078 2.512c-.265.21-.562.32-.863.32-.906 0-1.535-.738-1.535-1.793 0-1.05.629-1.789 1.535-1.789.3 0 .598.11.863.313V30.62h.88v4.914h-.88Zm0-2.203a.94.94 0 0 0-.672-.309c-.496 0-.835.426-.835 1.04 0 .616.34 1.038.835 1.038a.93.93 0 0 0 .672-.304Zm-5.183.972c.054.52.465.875 1.035.875.312 0 .66-.117 1.012-.324v.735a2.8 2.8 0 0 1-1.157.265c-1.027 0-1.746-.754-1.746-1.816 0-1.035.707-1.766 1.68-1.766.89 0 1.496.703 1.496 1.707 0 .098 0 .207-.016.324Zm.789-1.355c-.422 0-.746.316-.79.789h1.485c-.027-.469-.305-.79-.695-.79m-3.082.539v2.285h-.871v-3.418h.87v.34c.247-.273.548-.422.837-.422.097 0 .191.008.285.035v.778a1.1 1.1 0 0 0-.305-.04c-.285 0-.59.157-.816.442m-3.883.816c.055.52.46.875 1.031.875.317 0 .66-.117 1.016-.324v.735a2.8 2.8 0 0 1-1.156.265c-1.028 0-1.75-.754-1.75-1.816 0-1.035.707-1.766 1.68-1.766.894 0 1.5.703 1.5 1.707 0 .098 0 .207-.016.324Zm.789-1.355c-.422 0-.75.316-.789.789h1.48c-.027-.469-.304-.79-.691-.79m-3.832 2.824-.691-2.324-.688 2.324h-.785l-1.168-3.418h.871l.688 2.324.687-2.324h.785l.688 2.324.687-2.324h.871l-1.164 3.418Zm-5.32.082c-1.028 0-1.754-.746-1.754-1.793 0-1.05.726-1.789 1.754-1.789 1.027 0 1.75.738 1.75 1.79 0 1.046-.723 1.792-1.75 1.792m0-2.851c-.508 0-.864.433-.864 1.058 0 .63.356 1.063.864 1.063.504 0 .86-.434.86-1.063 0-.625-.356-1.058-.86-1.058m-3.825 1.082h-.78v1.687h-.872v-4.703h1.652c.954 0 1.633.621 1.633 1.512 0 .886-.68 1.504-1.633 1.504m-.12-2.305h-.66v1.594h.66c.503 0 .855-.325.855-.793 0-.48-.352-.801-.856-.801m64.753 2.64h-3.59c.082.864.711 1.118 1.426 1.118.73 0 1.305-.153 1.805-.406v1.484c-.5.277-1.16.48-2.035.48-1.79 0-3.043-1.125-3.043-3.351 0-1.88 1.066-3.371 2.808-3.371 1.746 0 2.657 1.492 2.657 3.383 0 .175-.016.562-.028.664m-2.636-2.542c-.461 0-.973.347-.973 1.18h1.898c0-.829-.476-1.18-.925-1.18m-5.77 5.218c-.644 0-1.035-.273-1.3-.468l-.005 2.09-1.832.39-.004-8.61h1.618l.097.454a2.05 2.05 0 0 1 1.438-.578c1.289 0 2.5 1.168 2.5 3.316 0 2.344-1.2 3.406-2.512 3.406m-.43-5.086c-.418 0-.683.153-.875.364l.012 2.742c.176.195.434.351.863.351.68 0 1.137-.746 1.137-1.738 0-.965-.465-1.719-1.137-1.719m-5.363-1.511h1.844v6.465h-1.844Zm0-2.067 1.844-.394v1.504l-1.844.394ZM67.2 32.344v4.383h-1.832v-6.465h1.586l.117.543c.43-.793 1.285-.633 1.532-.543v1.695c-.235-.074-.965-.187-1.403.387m-3.933 2.113c0 1.09 1.16.75 1.394.656v1.5c-.246.137-.687.246-1.289.246-1.09 0-1.906-.808-1.906-1.898l.008-5.918 1.793-.383v1.602h1.394v1.57h-1.394Zm-2.286.316c0 1.329-1.054 2.086-2.578 2.086a5.1 5.1 0 0 1-2.007-.418V34.68c.617.336 1.402.59 2.007.59.41 0 .703-.114.703-.454 0-.879-2.789-.55-2.789-2.59 0-1.308.993-2.09 2.48-2.09.61 0 1.22.094 1.825.34v1.739a4.1 4.1 0 0 0-1.824-.477c-.383 0-.625.114-.625.399 0 .832 2.808.437 2.808 2.636m0 0"
          style={{
            stroke: "none",
            fillRule: "evenodd",
            fill: "#424770",
            fillOpacity: 1,
          }}
        />
      </g>
      <filter
        id="powered-by-stripe_svg__a"
        width="100%"
        height="100%"
        x="0%"
        y="0%"
        filterUnits="objectBoundingBox"
      >
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
        />
      </filter>
    </defs>
    <use
      xlinkHref="#powered-by-stripe_svg__d"
      mask="url(#powered-by-stripe_svg__e)"
    />
    <use
      xlinkHref="#powered-by-stripe_svg__f"
      mask="url(#powered-by-stripe_svg__g)"
    />
  </svg>
);
export default SvgPoweredByStripe;
